import clsx from 'clsx'
import type { ExternalStorageProvider } from '@/constants/constants-external-storage'
import { PROVIDER_ICON_COMPONENTS } from '@/user_files/external-storage/ProviderMeta'

interface DmsProviderTabIconProps {
  provider: ExternalStorageProvider
  unhealthy: boolean
}

/** Decorative provider logo used by DMS tabs in file-selection modals. */
export function DmsProviderTabIcon({ provider, unhealthy }: DmsProviderTabIconProps) {
  const ProviderIcon = PROVIDER_ICON_COMPONENTS[provider]

  return (
    <span className="relative size-4" aria-hidden>
      <ProviderIcon className={clsx('size-4', unhealthy && 'grayscale opacity-[0.33]')} />
      {unhealthy ? <span className="absolute bottom-0 right-0 size-1.5 rounded-full bg-red-500" data-testid="dms-provider-tab-disconnected-dot" /> : null}
    </span>
  )
}
